<template>
  <v-dialog v-model="show" max-width="380" persistent>
    <v-card class="pb-6 pt-8 px-10 text-center" rounded="xl">
      <div class="text-h4 mb-6">🎉</div>
      <h3 class="text-h6 font-weight-bold mb-2">歡迎使用牙醫小幫手</h3>
      <div class="text-body-2 mb-5 tiffany-9--text font-weight-medium">
        你即將打造專屬的牙醫師品牌頁，<br>
        開始讓更多患者預約你！
      </div>
      <v-sheet
        class="bg-blue-50 px-5 py-6 mb-6 text-left"
        color="tiffany-1"
        elevation="0"
        :style="{ borderLeft: '4px solid var(--v-tiffany-9-base) !important' }"
      >
        <div>🏥 建立專業醫師形象</div>
        <div>📱 患者線上預約更方便</div>
        <div>⭐ 累積患者評價與信任</div>
      </v-sheet>
      <v-btn color="primary" class="px-8" @click="close">立即開始</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WelcomeOnBoard',
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.show = false
      this.$emit('start') // 通知外層要啟動導覽
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
